import { Popup } from '@hg/stylizator/components'
import * as React from 'react'

import { IActionCouponProps } from 'app/components/ActionCoupon'
import ActionCoupon from 'app/components/ActionCoupon/ActionCoupon'

export interface IAttributes extends IActionCouponProps {
  title: string
  description: React.ReactNode
  biggerTitle: boolean
}

export interface IProps {
  showAsBlock: boolean
}

const PopupBlock: React.FC<IAttributes & IProps> = (props) => {
  const attributes = props

  const [popupIsOpen, setPopupIsOpen] = React.useState(false)

  React.useEffect(() => {
    setTimeout(() => {
      setPopupIsOpen(true)
    }, 5000)
  }, [])

  return (
    <Popup
      {...attributes}
      popupIsOpen={popupIsOpen}
      onPopupToggle={(popupState: boolean) => {
        setPopupIsOpen(popupState)
      }}
      showAsBlock={attributes.showAsBlock}
      description={attributes.description}
      leftImageUrl="https://webassets.honeygain.com/uploads/2025/01/29095155/img_pop-up_money.svg"
      rightImageUrl="https://webassets.honeygain.com/uploads/2025/01/29095237/img_pop-up_bee_web.svg"
      mobileImageUrl="https://webassets.honeygain.com/uploads/2025/01/29160605/img_pop-up_bee_mobile.svg"
      leftRightButtons={
        attributes.displayCoupon ? (
          <ActionCoupon
            displayCoupon={attributes.displayCoupon}
            actionButtonClassName={attributes.actionButtonClassName}
            afterCopyText={attributes.afterCopyText || attributes.couponCode}
            align="center"
            couponButtonClassName={attributes.couponButtonClassName}
            couponCode={attributes.couponCode}
            couponRightButtonLink={attributes.couponRightButtonLink}
            couponRightButtonTitle={attributes.couponRightButtonTitle}
            couponSublabel={attributes.couponSublabel}
            sublabelColor="dark"
          />
        ) : null
      }
    />
  )
}

export default PopupBlock
